import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/_services/common.service';
import { HttpRequestService } from 'src/app/_services/http-request.service';
import * as io from 'socket.io-client';
import Swal from 'sweetalert2';
import {environment} from './../../../environments/environment';

@Component({
  selector: 'app-read-book',
  templateUrl: './read-book.component.html',
  styleUrls: ['./read-book.component.scss']
})
export class ReadBookComponent implements OnInit {

  private socket;
  basePath: any = environment.image_base_url;
  lang: any = 'EN';
  user_book_data: any = null;
  book_reading_data: any = null;
  user_book_pdf_data: any = null;
  src = "";
  pdf_error = '';
  replied_to_reading_notification: boolean = false;
  //src = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  
  constructor(private httpServices: HttpRequestService, private toastr: ToastrService,
    private commonService: CommonService, private modalService: NgbModal,
    public translate: TranslateService,
    private router: Router, private route: ActivatedRoute) {

      this.commonService.activelang.subscribe((lang) => {
        // this language will be used as a fallback when a translation isn't found in the current language
        translate.setDefaultLang(lang);
        this.lang = lang;
        // the lang to use, if the lang isn't available, it will use the current loader to get them
        translate.use(lang);
      });
      
      //initializing socket url
      this.socket = io(environment.socket_url);

    }

  ngOnInit() {
    //disable refresh option
    window.addEventListener("keyup", disableF5);
    window.addEventListener("keydown", disableF5);
    function disableF5(e) {
       if ((e.which || e.keyCode) == 116) e.preventDefault(); 
    };
  
    this.route.params.subscribe(params => {
      let user_book_id = params['id'];

      //subscribing to the socket evemt for reading notification by backend cron job
      this.socket.on('user-book-reading-notification-'+user_book_id, (data: any) => {
        //console.log(data, 'book notification');
        this.replied_to_reading_notification = false;

        setTimeout(() => {
          if (this.replied_to_reading_notification==false) {
            this.continue_not_reading(this.book_reading_data.id,user_book_id,'You did not replied to the notification');
          }
        }, 20000);

        Swal.fire({
          title: 'Are you still reading this book?',
          text: 'Please confirm!',
          showCancelButton: true,
          timer: 20000,
          confirmButtonText: 'Yes, I am reading!',
          cancelButtonText: 'No'
        }).then((result) => {
          if (result.value) {
            this.replied_to_reading_notification = true;
            this.continue_reading(this.book_reading_data.id,user_book_id);
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.replied_to_reading_notification = true;
            this.continue_not_reading(this.book_reading_data.id,user_book_id);
          }
        })

        
      })


      setTimeout(() => {
        this.readMyBook(user_book_id);
      }, 500);
      
    });

  }

  @HostListener('window:beforeunload', ['$event'])
  unloadHandler($event) {
    // Your logic on beforeunload
    //this.end_read(this.user_book_data.id)
    
    this.socket.emit('user-closed-reading-tab',{'user_book_id':this.user_book_data.id});
    return $event.returnValue=true;
  }
  readMyBook(user_book_id:any) {
    let userDetails = this.commonService.getLoginUserDetails();
    this.httpServices.setModule('action').post('read_my_book', {
      user_id: userDetails.id,
      lang: this.lang,
      id: user_book_id,
    }).subscribe((response) => {
      //console.log(response,'my_books');
      if (response.status == 'success') {
        this.user_book_data = response.data;
        this.book_reading_data = response.book_reading_data;
        if (response.data.book && response.data.book.media) {
          let pdf_data = response.data.book.media.filter((media:any) => {
            return media.media_type == 3;
          })

          if (pdf_data.length>0) {
            this.user_book_pdf_data = pdf_data[0];
            this.src = this.basePath+'e_book_pdf/' + pdf_data[0].media_value;

          } else {
            this.pdf_error = "PDF not found for this book";
            this.toastr.error('PDF not found', 'Error');
          }

          this.socket.emit('user-book-read',{'user_book_id':user_book_id});
          //console.log(this.user_book_pdf_data);
        }

      }
      if (response.status == 'error') {
        if (response.custom_error_message && response.custom_error_message!='') {
          this.toastr.error(response.custom_error_message, 'Error');
        } else {
          //this.toastr.error(response.data, 'Error');
          this.toastr.error('Error from the server', 'Error');
        }

        this.router.navigateByUrl('/profile/my-books');
        
      }
    }, (error) => {
      console.log(error);
    });
  }

  onError(error: any) {
    
    // do anything
    //console.log(error);
    this.pdf_error = "PDF can not be loaded";
  }

  end_read(user_book_id:any,need_redirect:boolean=true) {
   
    this.httpServices.setModule('action').post('remove_reading', {
      user_book_id:user_book_id
    }).subscribe((response) => {
      if (response.status == 'success') {
        let data = response.data;
        if (data.deleted=='yes') {
          this.socket.emit('user-book-read-removed',{'user_book_id':user_book_id});
        }
        if (need_redirect==true) {
          this.router.navigateByUrl('profile/my-books');
        }
        
      }
      if (response.status == 'error') { 
      }
    }, (error) => {
      console.log(error);
    });
  }


  continue_reading(book_reading_id:any,user_book_id:any) {
    let userDetails = this.commonService.getLoginUserDetails();
    this.httpServices.setModule('action').post('continue_read_my_book', {
      book_reading_id:book_reading_id,
      user_book_id: user_book_id,
    }).subscribe((response) => {
      //console.log(response,'my_books');
      if (response.status == 'success') {
        this.book_reading_data = response.data;
        this.socket.emit('user-book-read',{'user_book_id':user_book_id});
      }
      if (response.status == 'error') {
        if (response.custom_error_message && response.custom_error_message!='') {
          this.toastr.error(response.custom_error_message, 'Error');
        } else {
          //this.toastr.error(response.data, 'Error');
          this.toastr.error('Error from the server', 'Error');
        }

        this.router.navigateByUrl('/profile/my-books');
        
      }
    }, (error) => {
      console.log(error);
    });
  }

  continue_not_reading(book_reading_id:any,user_book_id:any,message:any='') {
    this.socket.emit('user-book-not-continue-read',{'user_book_id':user_book_id,'book_reading_id':book_reading_id});
    if (message) {
      Swal.fire(message);
      
    }

    this.router.navigateByUrl('/profile/my-books');
  
  }

 

}
